import { render } from "./originView.vue?vue&type=template&id=3cd4103d&scoped=true"
import script from "./originView.vue?vue&type=script&lang=js"
export * from "./originView.vue?vue&type=script&lang=js"

import "./originView.vue?vue&type=style&index=0&id=3cd4103d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd4103d"]])

export default __exports__